import { useCallback, useEffect, useRef, useState } from "react";

const MISSING_PRACTICES_HIGHLIGHT_DURATION_MS = 1000;
const MISSING_PRACTICE_CELL_SELECTOR = ".all-fields-data-table-view-cell-highlighted";
const TABLE_SCROLL_HOLDER_SELECTOR = ".ant-table-tbody-virtual-holder";

const scrollMissingPracticeCellIntoView = () => {
  const cell = document.querySelector(MISSING_PRACTICE_CELL_SELECTOR);
  const scrollHolder = document.querySelector(TABLE_SCROLL_HOLDER_SELECTOR);
  if (!cell || !scrollHolder) return;

  const cellBounds = cell.getBoundingClientRect();
  const holderBounds = scrollHolder.getBoundingClientRect();
  const distanceToCenter = cellBounds.left + cellBounds.width / 2 - (holderBounds.left + holderBounds.width / 2);
  scrollHolder.dispatchEvent(new WheelEvent("wheel", { deltaX: distanceToCenter, bubbles: true, cancelable: true }));
};

export const useMissingPracticesHighlight = () => {
  const [highlightedMissingRowKey, setHighlightedMissingRowKey] = useState<string | null>(null);
  const highlightClearTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const toggleHighlightMissingPractices = useCallback((rowKey: string) => {
    clearTimeout(highlightClearTimeoutRef.current);
    setHighlightedMissingRowKey((previous) => {
      if (previous === rowKey) return null;
      highlightClearTimeoutRef.current = setTimeout(() => setHighlightedMissingRowKey(null), MISSING_PRACTICES_HIGHLIGHT_DURATION_MS);
      requestAnimationFrame(scrollMissingPracticeCellIntoView);
      return rowKey;
    });
  }, []);

  useEffect(() => () => clearTimeout(highlightClearTimeoutRef.current), []);

  return { highlightedMissingRowKey, toggleHighlightMissingPractices };
};
